
export default {
  download: {
    documentTitle: 'ORS Route',
    download: 'Download',
    downloadFileName: 'Dateiname',
    downloadFormat: 'Download Format',
    downloadRoute: 'Download Route',
    preparingDownload: 'Download wird vorbereitet ...',
    fileReady: 'Datei bereit',
    errorPreparingFile: 'Fehler bei Vorbereitung',
    fileTooBigToBeDownloaded: 'Datei ist zu groß zum downloaden',
    standard: 'Standard'
  }
}
